import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Fragment } from "react";
import { MyHead } from "../../components/pages/MyHead";
import { Grid } from "@mantine/core";
import { SpecialistCard } from "../../components/pages/homepage/specialists/SpecialistCard";
import { useTranslation } from "next-i18next";
import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { isPhone } from "../../constants/env";
import { useColors } from "../../hooks/colors/useColors";
import { Container } from "../../components/UI/container/Container";
import { useLinks } from "../../components/pages/navbar/popover-link/useLinks";
import { isMobile } from "react-device-detect";
import { Footer } from "../../components/pages/homepage/footer/Footer";

export async function getStaticProps(context: any) {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, ["common"])),
    },
  };
}

function SpecialistListPage() {
  const { specialistCards } = useLinks();
  const { t } = useTranslation("common");
  const { colors } = useColors();

  return (
    <Fragment>
      <MyHead
        title={t("specialists-title")}
        description={t("team.doctors-h1-1")}
      />
      <PageHeader>
        <MyH1
          size={isPhone ? "2.5rem" : "3rem"}
          color="white"
          className="text-center"
        >
          {t("specialists-title")}
        </MyH1>
      </PageHeader>
      <Container noHeight>
        <Fragment>
          {specialistCards() && (
            <Fragment>
              {specialistCards().map((category) => {
                return (
                  <Grid key={category.title}>
                    <Grid.Col span={12}>
                      <h2
                        style={{ color: colors.primary }}
                        className={
                          isMobile
                            ? "text-center text-4xl"
                            : "text-center text-4xl"
                        }
                      >
                        {category.title.includes(".")
                          ? category.title.split(".")[1]
                          : category.title}
                      </h2>
                    </Grid.Col>
                    {category.specialists.map((specialist, index) => {
                      return (
                        <Grid.Col
                          key={specialist.name}
                          span={{ base: 12, md: 6, lg: 4 }}
                          className="flex justify-center"
                        >
                          <SpecialistCard specialist={specialist} />
                        </Grid.Col>
                      );
                    })}
                  </Grid>
                );
              })}
            </Fragment>
          )}
        </Fragment>
      </Container>
      <Footer
        isVisible={
          typeof specialistCards() !== "undefined" &&
          specialistCards().length > 3
        }
        delay
      />
    </Fragment>
  );
}

export default SpecialistListPage;
